import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { TipoServidorSustitutoDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class TipoServidorSustitutoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getTipoServidorSustitutoService(): Observable<BodyListResponse<TipoServidorSustitutoDTO>> {
    return this.http.get<BodyListResponse<TipoServidorSustitutoDTO>>(API_URL + '/api/v1/tipoServidorSustituto/todos');
  }

  guardarTipoServidorSustitutoService(tipoServidorSustitutoDTO: TipoServidorSustitutoDTO): Observable<TipoServidorSustitutoDTO> {
    return this.http.post<TipoServidorSustitutoDTO>(API_URL + '/api/v1/tipoServidorSustituto', tipoServidorSustitutoDTO);
  }

  getTipoServidorSustitutoPorCodigoTipoServidorSustitutoService(codigoTipoServidorSustituto: string): Observable<BodyResponse<TipoServidorSustitutoDTO>> {
    return this.http.get<BodyResponse<TipoServidorSustitutoDTO>>(API_URL + '/api/v1/tipoServidorSustituto/' + codigoTipoServidorSustituto);
  }
}
